import _ from 'lodash'
// eslint-disable-next-line no-restricted-syntax
import HTMLParser from '@wix/santa-core-utils/dist/cjs/coreUtils/core/htmlParser'
import { WRichTextDefinition } from '@wix/thunderbolt-becky-types'

export const getStyledTextUsedFonts = (styledTextDataItem: WRichTextDefinition['data']): Array<string> => {
	const usedFonts: Array<string> = []

	try {
		HTMLParser(styledTextDataItem.text, {
			start(tagName: string, attributes: Array<{ name: string; value: string }>) {
				const style = _.find(attributes, { name: 'style' })
				if (!style) {
					return
				}

				const valueUnquoted = style.value.replace(/&quot;/g, '')

				const fontFamily = /font-family:([^;]+);?/gi.exec(valueUnquoted)
				if (fontFamily) {
					usedFonts.push(fontFamily[1].trim())
				}
			},
		})
	} catch (e) {}

	return usedFonts
}
